import axios from 'axios'
import Cookies from 'js-cookie'
import { getCookie } from '@/utils/auth'
import { getToken,getSource } from '../utils/auth'
import qs from 'qs'
import md5 from 'md5'
import { toast } from '@/components/Toast'
import db from './db'

axios.defaults.timeout = 30000

const service = axios.create({})

// 登出状态
const logoutMsg = {
  '9009': 'token过期',
  '10000': '请重新登陆'
}

// HTTP方法
const HTTP_METHOD = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete'
}

// 内容类型
const CONTENT_TYPE = {
  JSON: 'application/json;charset=UTF-8',
  FORM: 'application/x-www-form-urlencoded; charset=UTF-8',
  FILE: 'multipart/form-data;charset=UTF-8'
}

// HTTP REQUEST CONFIG
const HTTP_CONFIG = {
  SALTSTR: '=JCCLJOoasBdsfK',
  CLIENT: 'web'
}

// 携带cookies
// request interceptor
service.interceptors.request.use(
  config => {
    const { method, data = {}, url } = config
    try {
      const timestamp = +new Date()
      const signUrl = `client=${HTTP_CONFIG.CLIENT}&data=${JSON.stringify(data)}&timestamp=${timestamp}=JCCLJOoasBdsfK`
      const sign = md5(signUrl).toUpperCase()
      let token = getToken()
      const source = getSource()
      config.headers['AppVer'] = 'web'
      config.headers['token'] = token
      config.headers['client'] = HTTP_CONFIG.CLIENT
      config.headers['sign'] = sign
      config.headers['timestamp'] = timestamp
      config.headers['clientType']= "40"
      config.headers['source']= source
      // 新加2.3支付，切换登录新需求
      const storeId = getCookie('native_organSign')
      const accountId = getCookie('native_accountId')
      const deviceUuid = getCookie('native_deviceUuid')
      const appVersion = getCookie('appVersion')
      const poiId = getCookie('native_poi_id')
    //   console.error('poiId=',poiId)
      config.headers['storeId'] = storeId || ''
      config.headers['accountId'] = accountId || ''
      config.headers['deviceUuid'] = deviceUuid || ''
      config.headers['poiId'] = poiId
      config.headers['appVersion'] = appVersion

      console.log("process.env.VUE_APP_TITLE", process.env.VUE_APP_TITLE)
      if (process.env.VUE_APP_TITLE === 'testgray') {
        console.log('灰度环境')
        console.log("process.env.VUE_APP_TITLE === 'testgray'", process.env.VUE_APP_TITLE === 'testgray')
        config.headers['ykqabtest'] = 1
      }


      // 注释结束
      config.url = process.env.VUE_APP_REQUEST_PHYSICIAN + (url.charAt(0) === '/' ? url.substring(1) : url)

      if (method === HTTP_METHOD.POST) {
        if (config['contentType'] === CONTENT_TYPE.FORM) {
          config.data = qs.stringify(data)
        }

        if (config['contentType'] === CONTENT_TYPE.JSON) {
          config.data = JSON.stringify(data)
        }

        if (config['contentType'] === CONTENT_TYPE.FILE) {
          config.data = data
        }
      }
      if (method === HTTP_METHOD.GET) {
        if (data !== undefined && Object.values(data).length > 0) {
          const params = Object.keys(data).reduce(
            (res, key) => res + key + '=' + encodeURIComponent(data[key]) + '&',
            ''
          )
          config.url = config.url + '?' + params.substring(0, params.length - 1)
        }
      }
    } catch (error) {
      console.log('请求配置错误')
      console.log(error)
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug

    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    if (res.code !== 0) {
      // const msg = (res.msg || '').toString().slice(0, 80)
      // 跳转到app登录页
      if (logoutMsg[res.code]) {
        // 请自行在引入 MessageBox
        toast({
          message: res.msg || logoutMsg[res.code],
          onClose: () => {
            window.location.href = 'protocol://action/logout'
            db.removeItem('employeeId')
            db.removeItem('drugstoreName')
          }
        })
      } else {
        if(res.code===8888){
          const appVersion = getCookie("native_version") || "1.0.0";
          const version = appVersion.split(".").join("");
          if(version<212){
            toast({
              message: res.msg
            })
          }else{
            window.location.href = 'protocol://action/toRecharge'
          }
        }else{
          toast({
            message: res.msg
          })
        }
      }
      return Promise.reject(res)
    }
    return response
  },
  error => {
    console.log('err' + error) // for debug
    const errMsg = error.message.indexOf('Network Error') >= 0 ? '网络异常' : '服务器异常'
    if (error.ctrToast) {
      toast({
        message: errMsg
      })
    }
    // toastFail(error.message)
    return Promise.reject(error)
  }
)

export default service
